import { render, staticRenderFns } from "./ConfirmMail1.vue?vue&type=template&id=79422286&"
import script from "./ConfirmMail1.vue?vue&type=script&lang=js&"
export * from "./ConfirmMail1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports